
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'ModalContactChannels',
  components: {
    NewModal: defineAsyncComponent(
      () => import('@/components/shared/NewModal.vue')
    ),
  },
  props: {
    isVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'No fue posible enviar el enlace de verificación',
    },
    description: {
      type: String,
      required: false,
      default:
        'No contamos con una cuenta de correo electrónico registrada para validar su identidad. Puede comunicarse con nosotros a través de los siguientes canales:',
    },
  },
  emits: ['close'],
  data() {
    return {
      phone: '601-7560568',
      email: 'contactenos@sc.jccolombia.co',
    };
  },
  computed: {
    phoneHref(): string {
      return this.phone.replace(/[^0-9]/g, '');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
